import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import styled from '@emotion/styled';
import { useTheme } from '@emotion/react';
import { forwardRef } from 'react';
const Component = styled.div();
export const GridContainer = forwardRef(({ cy, style, children, className, ...props }, ref) => {
    const theme = useTheme();
    const styles = typeof style === 'function' ? style(theme) : style;
    return (_jsx(Component, { ref: ref, "data-cy": cy, className: className, css: {
            display: 'grid',
            alignItems: 'center',
            ...styles
        }, ...props, children: children }));
});
//# sourceMappingURL=index.js.map